import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-analysis-upload-input',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './analysis-upload-input.component.html',
  styleUrl: './analysis-upload-input.component.scss'
})
export class AnalysisUploadInputComponent {
  @Input({ required: true })
  isDraggingFile = false;

  @Input()
  error = '';

  @Output()
  fileInputChange = new EventEmitter<Event>();

  @Output()
  dragEnter = new EventEmitter<DragEvent>();

  @Output()
  dragOver = new EventEmitter<DragEvent>();

  @Output()
  dragLeave = new EventEmitter<DragEvent>();

  @Output()
  dropFile = new EventEmitter<DragEvent>();

  @ViewChild('fileInput')
  private fileInputRef?: ElementRef<HTMLInputElement>;

  onFileInputChange(event: Event): void {
    this.fileInputChange.emit(event);
  }

  onDragEnter(event: DragEvent): void {
    this.dragEnter.emit(event);
  }

  onDragOver(event: DragEvent): void {
    this.dragOver.emit(event);
  }

  onDragLeave(event: DragEvent): void {
    this.dragLeave.emit(event);
  }

  onDrop(event: DragEvent): void {
    this.dropFile.emit(event);
  }

  resetInput(): void {
    if (this.fileInputRef) {
      this.fileInputRef.nativeElement.value = '';
    }
  }
}
